module.exports = __webpack_public_path__ + "media/images/svg-icon/apps-d45d8f98e413307163b354015ba2a95e.svg";